import React from "react";
import { useInView } from "react-intersection-observer";
import { LoadableComponent } from "@loadable/component";

interface LazyComponentProps {
  component: LoadableComponent<any>;
  componentProps?: Object;
}

export const LazyComponent = (props: LazyComponentProps) => {
  const [componentRef, componentInView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  return (
    <div ref={componentRef}>
      {componentInView && <props.component {...(props.componentProps ?? {})} />}
    </div>
  );
};
